import React, { InputHTMLAttributes, useState } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  error,
  className = '',
  onFocus,
  onBlur,
  ...props
}, ref) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  return (
    <input
      ref={ref}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={`
        w-full
        px-4
        py-3
        bg-white
        border
        rounded-lg
        text-black
        placeholder:text-[#d2d2d2]
        focus:outline-none
        transition-all
        disabled:opacity-50
        disabled:cursor-not-allowed
        ${error ? 'border-red-500' : 'border-white/20'}
        ${isFocused && !error ? 'border-white/60' : ''}
        ${className}
      `}
      {...props}
    />
  );
});

Input.displayName = 'Input';
